crDeliverySettings.min_days = 10;
//07821 
//07821, 07837, 07843, 07874
var crHideDeliveryDate = true;
var ifThisZipDisplayDeliveryCalendar = function(customerZip){
  console.log(customerZip)
  if (customerZip == '07821' || customerZip == '07837' || customerZip == '07843' || customerZip == '07874') {
    return false;
  }
  return true;	
}